/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../../utils/lodashCustom';

export function restructureTasksAccountSettingsModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    accountId: lc.get(data, 'account_id'),
    premoderationState: lc.get(data, 'premoderation_state')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksAccountSettingsService/restructuring/index.js